import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import DashboardView from 'views/Administration/UserCredits/Dashboard';
import ParticipantService from 'api/Participant';
import SettingsActions from 'store/reducers/Settings';
import AccountActions from 'store/reducers/Account';
import { useDelete, useFetchTableData } from 'hooks';

const Dashboard = ( {
  parentPath, toggleErrorAlert, toggleLoading, user,
} ) => {
  const [dataSubmitted, setDataSubmitted] = useState( new Date().valueOf() );

  const [fetchParticipants, participants, participantsLoading] = useFetchTableData( {
    promise: ParticipantService.getParticipants,
    toggleErrorAlert,
    deps: [dataSubmitted],
  } );

  const reloadData = useCallback( () => {
    setDataSubmitted( new Date().valueOf() );
  }, [] );

  const deleteEntity = useDelete( {
    promise: ParticipantService.deleteParticipant,
    callback: reloadData,
    toggleLoading,
    toggleErrorAlert,
  } );

  return (
    <DashboardView
      participants={participants}
      participantsLoading={participantsLoading}
      parentPath={parentPath}
      onFetchParticipants={fetchParticipants}
      onDelete={deleteEntity}
      userData={user}
    />
  );
};

const mapStateToProps = ( { user } ) => ( {
  user,
} )

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
  updateAccountInfo: AccountActions.updateInfo,
} );

export default connect( mapStateToProps, mapDispatchToProps )( Dashboard );
